import {
  Backdrop,
  Grid,
  SwipeableDrawer,
  styled,
  useMediaQuery,
} from '@mui/material';
import cn from 'classnames';
import React, { useState } from 'react';

import Error404 from '../../../pages/404/404';
import '../../../pages/Card/Card.sass';
import Heading from '../../../ui/heading/Heading';
import Review from '../../../ui/review/Review';
import { Breadcrumbs } from '../../Breadcrumbs';
import CardItemSkeleton from '../../Skeleton/Card/CardItemSkeleton';
import { CustomSnackbar } from '../../Snackbar';

import styles from './Card.module.sass';
import CardDescription from './CardDescription/CardDescription';
import CardGallery from './CardGallery/CardGallery';
import CardInformation from './CardInformation/CardInformation';
import CardInteraction from './CardInteraction/CardInteraction';
import { useCards } from './useCard';

// Кастомный стиль
const CssSwipableDrawer = styled(SwipeableDrawer)({
  '& .MuiDrawer-paper': {
    top: '114px',
    backgroundColor: '#F6F8FB',
  },
});

// Стилизованный компонент для изменения фона
const StyledBackdrop = styled(Backdrop)`
  background-color: rgba(0, 0, 0, 0);
  z-index: -1;
  top: 114px;
`;
//Карточка товара
const Card = () => {
  const { card, actions } = useCards();
  const tableScreen = useMediaQuery('(max-width:900px)');
  const mobileScreen = useMediaQuery('(max-width:539px)');
  const [showAllReviews, setShowAllReviews] = useState(false);

  const handleShowAllReviews = () => {
    window.scrollTo({ top: 0, behavior: 'auto' });
    setShowAllReviews(!showAllReviews);
  };

  const handleHideAllReviews = () => {
    setShowAllReviews(!showAllReviews);
  };

  if (!card.catalog_item) return <Error404 />;

  return (
    <div className={styles.page}>
      <div className={cn(styles.wrapper, styles.desktop)}>
        <Breadcrumbs navigation={card.navigation} />
        {card.isLoading ? (
          <CardItemSkeleton />
        ) : (
          <>
            {!mobileScreen && (
              <Heading
                className={styles.title}
                title={card.catalog_item.title}
              />
            )}
            <Grid container className={cn(styles.content, styles.desktop)}>
              {!mobileScreen && (
                <Grid item lg={4} md={12}>
                  <CardGallery
                    item={card.catalog_item}
                    activeImage={card.activeImageIndex}
                    setActiveImage={actions.handleSetActiveImageIndex}
                  />
                </Grid>
              )}
              <Grid item lg={7} md={12}>
                <Grid container spacing={2}>
                  <Grid item lg={7} md={6} sm={12} xs={12}>
                    <CardInteraction
                      item={card.catalog_item}
                      activeImageIndex={card.activeImageIndex}
                      handleSetActiveImageIndex={
                        actions.handleSetActiveImageIndex
                      }
                    />
                  </Grid>
                  {tableScreen && (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <CardDescription
                        text={card.parametersText}
                        showMore={card.showMore}
                        handleShowMore={actions.handleShowMore}
                      />
                    </Grid>
                  )}
                  <Grid item lg={5} md={6} sm={12} xs={12}>
                    <CardInformation
                      item={card.catalog_item}
                      showAddress={card.showAddress}
                      handleShowAddress={actions.handleShowAddress}
                    />
                  </Grid>
                  {!tableScreen && (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <CardDescription
                        text={card.parametersText}
                        showMore={card.showMore}
                        handleShowMore={actions.handleShowMore}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid item lg={4.9} md={7} sm={12} xs={12}>
                <Review
                  onOpen={handleShowAllReviews}
                  onClose={handleHideAllReviews}
                  showAllReviews={showAllReviews}
                />
              </Grid>
              {showAllReviews && (
                <Grid item lg={4.9} md={7} sm={12} xs={12}>
                  <CssSwipableDrawer
                    anchor="bottom"
                    open={showAllReviews}
                    onOpen={handleShowAllReviews}
                    onClose={handleHideAllReviews}
                    variant="temporary"
                    BackdropComponent={StyledBackdrop}
                  >
                    <Review
                      onOpen={handleShowAllReviews}
                      onClose={handleHideAllReviews}
                      showAllReviews={showAllReviews}
                    />
                  </CssSwipableDrawer>{' '}
                </Grid>
              )}
            </Grid>
          </>
        )}
      </div>

      {/*      <div className="card-page__wrapper mobile">
               <Breadcrumbs navigation={navigation} />

        <div className="card-page__content ">
          <div className="card-page__left">
            <div className="card-page__top"></div>
            <div className="card-page__right"></div>
          </div>
        </div>
      </div>*/}

      <CustomSnackbar />
    </div>
  );
};

export default Card;
